const metodos = {
  formatarParaPadraoBrasileiro: valor => new Date(Date.parse(`${valor}-04:00`)).toLocaleDateString('pt-BR'),
  formatarDataParaAPI: (valor) => {
    const elementosDaData = valor.split('/');
    return elementosDaData[2].concat('-').concat(elementosDaData[1]).concat('-').concat(elementosDaData[0]);
  },
  formatarDatePickerParaApi: (data) => {
    if(data == null || data == undefined) return data;
    const year = data.getFullYear();
    const month = (data.getMonth() + 1).toString().padStart(2, '0');
    const day = data.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  },
};

/* eslint-disable no-param-reassign, no-unused-vars */
const plugin = {
  install(Vue, options) {
    Vue.prototype.$tempo = metodos;
  },
};

export default plugin;


// WEBPACK FOOTER //
// ./src/plugins/tempo.js